import { render, staticRenderFns } from "./wing.vue?vue&type=template&id=4e8b8068"
import script from "./wing.vue?vue&type=script&lang=js"
export * from "./wing.vue?vue&type=script&lang=js"
import style0 from "./wing.vue?vue&type=style&index=0&id=4e8b8068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports